/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */

import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import './LoanDataDisplay.scss';
import fmt from 'indian-number-format';

// Define TypeScript interfaces
interface InterestAccruedItem {
  loanNumber: string;
  dateOfLoan: string;
  branch: string;
  customerName: string;
  principal: number;
  outstandingPrincipal: number;
  scheme: string;
  interestAsPerScheme: number;
  currentInterestRate: number;
  interestDays: number;
  accuredInterest: number;
}

interface InterestAccruedProps {
  data: InterestAccruedItem[];
}

const columns: ColumnsType<InterestAccruedItem> = [
  {
    title: 'S.No',
    dataIndex: 'serialNumber',
    key: 'serialNumber',
  },
  {
    title: 'Loan Number',
    dataIndex: 'loanNumber',
    key: 'loanNumber',
  },
  {
    title: 'Date of Loan',
    dataIndex: 'dateOfLoan',
    key: 'dateOfLoan',
  },
  {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch',
  },
  {
    title: 'Customer Name',
    dataIndex: 'customerName',
    key: 'customerName',
  },
  {
    title: 'Principal',
    dataIndex: 'principal',
    key: 'principal',
    render: (amt: number) => fmt.format(amt),
  },
  {
    title: 'Outstanding Principal',
    dataIndex: 'outstandingPrincipal',
    key: 'outStandingPrincipal',
    render: (amt: number) => fmt.format(amt),
  },
  {
    title: 'Scheme',
    dataIndex: 'scheme',
    key: 'scheme',
  },
  {
    title: 'Interest as per Scheme',
    dataIndex: 'interestAsPerScheme',
    key: 'interestAsPerScheme',
    render: (rate: number) => `${rate}%`,
  },
  {
    title: 'Current Interest Rate',
    dataIndex: 'currentInterestRate',
    key: 'currentInterestRate',
    render: (rate: number) => `${rate}%`,
  },
  {
    title: 'Interest Days',
    dataIndex: 'interestDays',
    key: 'interestDays',
  },
  {
    title: 'Accrued Interest',
    dataIndex: 'accuredInterest',
    key: 'accuredInterest',
    render: (amt: number) => fmt.format(amt),
  },
  {
    title: 'Penal Interest',
    dataIndex: 'penalInterest',
    key: 'penalInterest',
    render: (amt: number) => fmt.format(amt),
  },
];

const InterestAccruedDisplay: React.FC<InterestAccruedProps> = ({ data }) => {
  return (
    <div className="loan-data-container">
      <h2>Interest Accrued Report</h2>
      <Table
        columns={columns}
        dataSource={data}
        rowKey={(_, idx) => (idx !== undefined ? idx.toString() : '')}
        pagination={{ pageSize: 10 }}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
};

export default InterestAccruedDisplay;
